export const GHGEmissionConst = [
  'Total GHG Emissions',
  'Scope 1 GHG emissions',
  'Scope 2 GHG emissions',
  'Scope 3 GHG emissions'
];
